/** Indicador de dashboard v2: icono, etiqueta y valor (design.md §22.7). */
import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import { MobileIcon, type MobileIconName } from './MobileIcon';

type KpiCardProps = {
  icon: MobileIconName;
  label: string;
  value: string | number;
  trend?: ReactNode;
  className?: string;
};

export function KpiCard({ icon, label, value, trend, className }: KpiCardProps) {
  return (
    <div className={clsx('rounded-card bg-white p-4 shadow-card', className)}>
      <div className="flex items-start justify-between gap-2">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-border-light bg-bg-tertiary text-text-secondary">
          <MobileIcon name={icon} className="h-5 w-5" />
        </span>
        {trend && <div className="shrink-0">{trend}</div>}
      </div>
      <p className="mt-3 line-clamp-2 min-h-[2rem] text-xs font-medium text-text-secondary">{label}</p>
      <p className="mt-0.5 truncate text-2xl font-bold tabular-nums text-text-heading">{value}</p>
    </div>
  );
}
